
import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit
} from '@angular/core';
import { SettingsOptions, SettingsOptionsTranslations } from '@go-modules/enums/settings-options';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { filter } from 'rxjs';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { LinkResult } from '@go-modules/enums';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { TranslateService } from '@ngx-translate/core';
import { RouterService } from '@go-modules/services/router/router.service';

@Component({
	selector: 'user-settings',
	templateUrl: './user-settings.component.html',
	styleUrls: ['./user-settings.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class UserSettingsComponent implements OnInit {
	public account;
	public settingsOptions: SettingsOptions[] = Object.values(SettingsOptions);
	public settingsOptionsTranslations = SettingsOptionsTranslations;
	public selectedOption = this.settingsOptions[0];
	public environmentVarsService: EnvironmentVarsService;
	private readonly PARTNER_GOREACT = 'GO_REACT';

	constructor (
		private ngxGoToastService: NgxGoToastService,
		private routerService: RouterService,
		@Inject(selectedServiceToken) public selectedService: SelectedService,
		private translateService: TranslateService) {}

	public showLink (option) {
		if (option === SettingsOptions.BILLING_HISTORY) {
			if (this.isLTI()) {
				const partners = clientSettings.partners;
				const isGoReactPartner = partners.length ?
					partners.every((value) => value.guid === this.PARTNER_GOREACT) : true;
				return isGoReactPartner;
			}
		}

		if(option === SettingsOptions.ACTIVITY_DEFAULTS) {
			return !!this.account;
		}

		return true;
	}

	public ngOnInit (): void {
		this.environmentVarsService = EnvironmentVarsService.getInstance();

		if (this.routerService.getCurrentQueryParams().tab &&
			this.settingsOptions.includes(this.routerService.getCurrentQueryParams().tab)) {
			this.selectedOption = this.routerService.getCurrentQueryParams().tab;
		}

		const linkSuccessParam = this.routerService.getCurrentQueryParams()['link-result'];
		const linkProvider = this.routerService.getCurrentQueryParams().provider;
		if (linkSuccessParam) {
			switch(linkSuccessParam) {
				case LinkResult.SUCCESS:
					this.translateService.get('common_sso-account-successfully-linked', { provider: linkProvider }).subscribe((message) => {
						this.ngxGoToastService.createToast({
							type: GoToastStatusType.SUCCESS,
							message
						});
					});
					break;
				case LinkResult.ACCOUNT_TAKEN:
					this.translateService.get('common_sso-account-linked-account-taken', { provider: linkProvider }).subscribe((message) => {
						this.ngxGoToastService.createToast({
							type: GoToastStatusType.ERROR,
							message
						});
					});
					break;
				// No default needed since param supplied with no state value
			}
		}

		const accountGroup = this.selectedService.getAccount();
		this.account = accountGroup?.isAccount() ? accountGroup: null;

		this.selectedService.selectedSubject.asObservable()
			.pipe(filter(() => this.selectedService.getAccount()?.isAccount()))
			.subscribe(() => {
				this.account = this.selectedService.getAccount();
			});
	}

	public isLTI () {
		return this.environmentVarsService.environmentIs(ENVIRONMENTS.LTI);
	}
}
